import { render } from "./termspage.vue?vue&type=template&id=889e4b6a&scoped=true"
import script from "./termspage.vue?vue&type=script&lang=js"
export * from "./termspage.vue?vue&type=script&lang=js"

import "./termspage.vue?vue&type=style&index=0&id=889e4b6a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-889e4b6a"]])

export default __exports__